<script>
  export let CtaRecentText = null;
  export let CtaSimilarText = null;
  let preview = 'similar';

  let recentProducts = [
    {
      image: '/img/preview-product-1.png',
    },
    {
      image: '/img/preview-product-2.png',
    },
    {
      image: '/img/preview-product-3.png',
    },
  ];
</script>

<section class="cta-preview-wrapper">
  <div class="sb-cta  sb-cta-pdp">
    <span class="sb-cta--close  "
      ><svg width="8" height="8" viewBox="0 0 8 8" fill="none"
        ><path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.96492 1.72855C7.16018 1.53329 7.16018 1.21671 6.96492 1.02145C6.76965 0.826184 6.45307 0.826184 6.25781 1.02145L3.99318 3.28607L1.72855 1.02145C1.53329 0.826184 1.21671 0.826184 1.02145 1.02145C0.826184 1.21671 0.826184 1.53329 1.02145 1.72855L3.28607 3.99318L1.02145 6.25781C0.826184 6.45307 0.826184 6.76965 1.02145 6.96492C1.21671 7.16018 1.53329 7.16018 1.72855 6.96492L3.99318 4.70029L6.25781 6.96492C6.45307 7.16018 6.76965 7.16018 6.96492 6.96492C7.16018 6.76965 7.16018 6.45307 6.96492 6.25781L4.70029 3.99318L6.96492 1.72855Z"
          fill="white"
        /></svg
      ></span
    >
    <p class="sb-cta-title  ">
      {#if preview == 'similar'}
        {CtaSimilarText ? CtaSimilarText : 'Want to see similar products?'}
      {:else}
        {CtaRecentText ? CtaRecentText : "Products you've recently viewed"}
      {/if}
    </p>
    <div class="sb-cta--products  ">
      {#each recentProducts as product}
        <div class="sb-cta--product ">
          <img src={product.image} alt="CTA preview product" />
        </div>
      {/each}
    </div>
    <p class="preview-switch">
      Preview for :
      <span on:click={() => (preview = 'similar')} class:active={preview == 'similar'}>Similar</span>
      <span on:click={() => (preview = 'recent')} class:active={preview == 'recent'}>Recent</span>
    </p>
  </div>
</section>

<style>.cta-preview-wrapper{left:100%;margin:1em 0 0 1em;overflow:hidden;position:absolute;top:0;width:260px}.sb-cta{flex-direction:column}.sb-cta,.sb-cta--products{display:flex;justify-content:space-between}.sb-cta-title{border-radius:8px;box-shadow:0 1px 6px 0 rgba(117,141,166,.55);color:var(--t-c-l);font-size:.8rem;font-weight:100;margin:.5em .1em 1em;max-width:100%;padding:12px 8px}.sb-cta--close{align-items:center;background:rgba(0,0,0,.55);border-radius:20%;display:flex;height:24px;justify-content:center;width:24px}.sb-cta--product img{border:1px solid var(--brd-l);cursor:pointer;overflow:hidden;padding:4px}.preview-switch{color:var(--t-c);font-size:.7rem;margin-top:1.5em}.preview-switch span{color:var(--t-c-l);cursor:pointer;font-size:.9rem;margin-right:.3em}span.active{color:var(--t-c);text-decoration:underline}@media (max-width:1200px){.cta-preview-wrapper{display:none}}</style>
